<script>
// import axios from "axios";

import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import { required } from "vuelidate/lib/validators";
import Vuetable from "vuetable-2";
import VueBarcode from "vue-barcode";
import VuetablePagination from "vuetable-2/src/components/VuetablePagination";
import Swal from "sweetalert2";
import Vue from "vue";
import axios from "axios";
import { FulfillingBouncingCircleSpinner } from "epic-spinners";
import MaskedInput from 'vue-text-mask'
// register the plugin on vue
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import Toasted from "vue-toasted";
import {
  authMethods,
  authFackMethods,
  notificationMethods,
} from "@/state/helpers";
import { mapState } from "vuex";
import { authComputed } from "@/state/helpers";
Vue.use(Toasted);
// Lets Register a Global Error Notification Toast.

/**
 * Categoria component
 */
export default {
  page: {
    title: "Concentrado",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
    barcode: VueBarcode,
    'masked-input': MaskedInput,
    Vuetable,
    VuetablePagination,
    "fulfilling-bouncing-circle-spinner": FulfillingBouncingCircleSpinner,
  },
  data() {
    return {
      repit_codigo: true,
      repit: true,
      apiUrl: process.env.VUE_APP_URL,
      apiBase: process.env.VUE_APP_URL + "concentrado/get",
      userT: this.$store.state.authfack.user,
      httpOptions: {
        headers: { "x-token": this.$store.state.authfack.user.token },
      },
      css: {
        table: {
          tableClass: "table table-striped table-bordered table-hovered",
          loadingClass: "loading",
          ascendingIcon: "glyphicon glyphicon-chevron-up",
          descendingIcon: "glyphicon glyphicon-chevron-down",
          handleIcon: "glyphicon glyphicon-menu-hamburger",
        },
        pagination: {
          infoClass: "pull-left",
          wrapperClass: "vuetable-pagination pull-right",
          activeClass: "btn-primary",
          disabledClass: "disabled",
          pageClass: "btn btn-border",
          linkClass: "btn btn-border",
          icons: {
            first: "",
            prev: "",
            next: "",
            last: "",
          },
        },
      },
      mask_quetzal: createNumberMask({
          prefix: "Q ",
          suffix: "",
          includeThousandsSeparator: true,
          thousandsSeparatorSymbol: ",",
          allowDecimal: true,
          decimalSymbol: ".",
          decimalLimit: 2, // how many digits allowed after the decimal
          integerLimit: 10, // limit length of integer numbers
          allowNegative: false,
          allowLeadingZeroes: false,
      }),
      formConcentrado: {
        nombre: "",
        descripcion: "",
        precio_compra: "0",
        precio_venta: "0",
        existencia: 0,
        codigo_stock : "",
        state: true,
        id: 0,
      },
      updating: false,
      estadotabla: true,
      title: "Concentrado",
      itemst: [
        {
          text: "Inventario",
          href: "/",
        },
        {
          text: "Concentrado",
          active: true,
        },
      ],
      fields: [
        {
          name: "nombre_producto",
          title: "Nombre",
          sortField: "nombre_producto",
          width: "20%",
        },
        {
          name: "descripcion_producto",
          title: "Descripción",
          sortField: "descripcion_producto",
          width: "20%",
        },
        {
          name: "codigo_stock",
          title: "Código",
          sortField: "codigo_stock",
          width: "10%",
        },
        {
          name: "existencia",
          title: "Existencia",
          sortField: "existencia",
          width: "10%",
        },
        
        {
          name: "precio_compra",
          title: "Precio compra",
          titleClass: "",
          dataClass: "text-muted",
          width: "20%",
        },
        {
          name: "precio_venta",
          title: "Precio Venta",
          titleClass: "",
          dataClass: "text-muted",
          width: "20%",
        },
        {
          name: "estado",
          title: "Estado",
          titleClass: "",
          dataClass: "text-muted",
          width: "10%",
        },
        {
          name: "actions",
          title: "Acciones",
          titleClass: "",
          width: "10%",
        },
      ],
      searchType: [{ nombre: "Nombre", value: "nombre" }],
      options: {
        theme: "outline",
        position: "top-right",
        duration: 5000,
        keepOnHover: true,
        action: {
          text: "X",
          onClick: (e, toastObject) => {
            toastObject.goAway(0);
          },
        },
      },
      loadingtable: false,
      sortBy: "nombre_producto",
      sortDesc: false,
      searchLabel: { nombre: "Nombre", value: "nombre" },
      filterLabel: { nombre: "Nombre", value: "nombre" },
      showModalL: false,
      showModalN: false,
      showModalD: false,
      showModalA: false,
      showModalE: false,
      totalInversion:0,
      submitted: false,
      data: [],
      pageOptions: [4, 10, 15, 20],
      search: "",
      page: 1,
      perPage: 20,
      from: 0,
      to: 0,
      total: 0,
      lastPage: 0,
    };
  },
  validations: {
    formConcentrado: {
      nombre: {
        required,
        // async isUnique(value) {
        //   if (value === "") return true;
        //   // simulate async call, fail for all logins with even length
        //   let response = await axios
        //     .get(
        //       this.apiUrl +
        //         "categorias/nombre_repetido?nombre=" +
        //         value +
        //         "&id=" +
        //         this.formConcentrado.id, {
        //         headers: { "x-token": this.userT.token },
        //       }
        //     )
        //     .catch(console.log);
        //   this.repit = response.data.msg;
        //   return response.data.msg;
        // },
      },
      descripcion: { required },
      precio_compra: { required },
      precio_venta: {required },
      existencia: {required },
      codigo_stock: {required, 
        async isUnique (value) {
            if (value === '') return true
            let response = await axios.get( process.env.VUE_APP_URL +'concentrado/codigo_repetido?codigo='+ value + '&id='+this.formConcentrado.id ,{
            headers: { "x-token": this.userT.token}
          } ).catch(console.log);
            // console.log(response);
            this.repit_codigo = response.data.data;
            return response.data.data
          } 
       },
    },
  },
  mounted() {
    this.getAllInversion();
    const usuario = this.$store.state.authfack.user;
    if (usuario == "" || usuario == null || usuario == "null") {
      this.logout();
      location.reload();
    } else {
      axios({
        baseURL: this.apiUrl + "auth/checkToken",
        method: "POST",
        headers: { "x-token": usuario.token },
      })
        .then((res) => {
          if (res.data.success) {
            // this.$router.push("/");
          }
        })
        .catch(() => {
          this.logout();
          location.reload();
        });
    }
  },
  watch: {},
  methods: {
    ...authMethods,
    ...authFackMethods,
    ...notificationMethods,

    //modal y validaciones
    limpiarModal() {
      this.formConcentrado.nombre = "";
      this.formConcentrado.id = 0;
      this.formConcentrado.descripcion = "";
      this.formConcentrado.precio_compra = "";
      this.formConcentrado.precio_venta = "";
      this.formConcentrado.existencia = "";
      this.formConcentrado.codigo_stock = "";
    },
    validaciones(opc) {
      this.submitted = true;
      // console.log(this.repit)
      // stop here if form is invalid

      this.$v.$touch();
      // console.log(this.$v.$invalid, this.repit);
      if (this.$v.$invalid || this.repit_codigo == false) {
        return;
      } else {
        this.showModalL = true;
        if (opc == "save") {
          this.save();
        }
        if (opc == "update") {
          this.update();
        }
      }
    },
    //Desactivar registro
    desactivate() {
      const { id, nombre } = this.formConcentrado;
      axios
        .put(process.env.VUE_APP_URL + "concentrado/desactivate", {
          id: id,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          this.showModalD = false;
          Vue.toasted.error(nombre + " Desactivado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para desactivar", this.options);
        });
    },

    //ACtivar registro
    activate() {
      const { id, nombre } = this.formConcentrado;
      axios
        .put(process.env.VUE_APP_URL + "concentrado/activate", {
          id: id,
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          this.showModalA = false;
          Vue.toasted.info(nombre + " Activado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("There was an error!", error);
          Vue.toasted.error("Error para activar", this.options);
        });
    },
    convertMaskToNumber(value) {
      var myNumber = "";
      for (var i = 0; i < value.length; i += 1) {
        if (
          value.charAt(i) === "Q" ||
          value.charAt(i) === "," ||
          value.charAt(i) === " "
        ) {
          continue;
        } else {
          myNumber += value.charAt(i);
        }
      } 
      return parseFloat(myNumber).toFixed(2);
    },
    //Guardar registro
    save() {
      const { nombre, descripcion, precio_compra, precio_venta, codigo_stock, existencia } = this.formConcentrado;
      const me = this;
      axios
        .post(process.env.VUE_APP_URL + "concentrado/store", {
          nombre_producto: nombre,
          descripcion_producto: descripcion,
          precio_compra: parseFloat(me.convertMaskToNumber(precio_compra)),
           precio_venta:  parseFloat(me.convertMaskToNumber(precio_venta)), codigo_stock, existencia
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          Vue.toasted.success(nombre + " Guardado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
          this.showModalN = false;
          this.limpiarModal();
          this.submitted = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },
    //ACtualizar registro
    update() {
      const { nombre, descripcion, precio_compra, precio_venta, codigo_stock, existencia, id  } = this.formConcentrado;
      const me = this;
      axios
        .put(process.env.VUE_APP_URL + "concentrado/update", {
          id: id,
          nombre_producto: nombre,
          descripcion_producto: descripcion,
          precio_compra: parseFloat(me.convertMaskToNumber(precio_compra)),
           precio_venta:  parseFloat(me.convertMaskToNumber(precio_venta)), codigo_stock, existencia,
           estado_producto : 1
        }, {
                headers: { "x-token": this.userT.token },
              })
        .then(() => {
          Vue.toasted.success(nombre + " Actualizado", this.options);
          const currentPage = this.$refs.vuetable.currentPage;
          this.$refs.vuetable.refresh(); 
          // console.log(currentPage);
          setTimeout(() => {
            this.$refs.vuetable.changePage(currentPage); // Vuelve a la página actual
          }, 100)
          this.showModalE = false;
          this.limpiarModal();
          this.submitted = false;
        })
        .catch((error) => {
          this.errorMessage = error.message;
          console.error("Error!", error);
          Vue.toasted.error("Error para guardar", this.options);
        })
        .finally(() => {
          this.showModalL = false;
        });
    },

    //Timer de registro guardado para notificacion
    timer() {
      let timerInterval;
      Swal.fire({
        title: "Auto close alert!",
        html: "I will close in <b></b> milliseconds.",
        timer: 2000,
        timerProgressBar: true,
        onBeforeOpen: () => {
          Swal.showLoading();
          timerInterval = setInterval(() => {
            Swal.getContent().querySelector("b").textContent =
              Swal.getTimerLeft();
          }, 100);
        },
        onClose: () => {
          clearInterval(timerInterval);
        },
      }).then((result) => {
        if (
          /* Read more about handling dismissals below */
          result.dismiss === Swal.DismissReason.timer
        ) {
          console.log("I was closed by the timer"); // eslint-disable-line
        }
      });
    },
    //Buscador dentro de la tabala
    onFiltered() {
      this.search = this.search.toLowerCase();
      this.$refs.vuetable.refresh();
    },
    //enviar datos a la Paginacion
    onPaginationData(paginationData) {
      this.to = paginationData.to;
      this.total = paginationData.total;
      this.lastPage = paginationData.last_page;
      this.items = paginationData.data;
      this.$refs.pagination.setPaginationData(paginationData);
    },
    //Cambiar tamaño de filas en la tabala para mostrar
    changePageSize() {
      this.$refs.vuetable.refresh();
    },

    // Cambiar el valor del dropwdown para poder filtrar
    changeTypeSearch(type) {
      this.searchLabel = type;
      this.$refs.vuetable.refresh();
    },
    //Cuando cambia de pagina
    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    async getAllInversion() {
      // console.log('hola')
      const response = await axios.get(
        process.env.VUE_APP_URL + "concentrado/get_inversion",
        {
          headers: { "x-token": this.userT.token },
        }
      );
      this.totalInversion = response.data.data.toFixed(2);
      // console.log(   response);
    },
    //Query para realizar busquedas y ordenar
    makeQueryParams(sortOrder, currentPage) {
      return sortOrder[0]
        ? {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          }
        : {
            criterio: sortOrder[0] ? sortOrder[0].sortField : "createdAt",
            categoria: this.searchLabel.value,
            order: sortOrder[0] ? sortOrder[0].direction : "desc",
            page: currentPage,
            limite: this.perPage,
            search: this.search,
          };
    },
    money(value) {
      return (
          "Q " +
          parseFloat(value)
              .toFixed(2)
              .replace(/(\d)(?=(\d{3})+\.)/g, "$1,")
      );
    },
    //Para abrir los modales y pasar los datos de la fila
    onActionClicked(action, data) {
      if (action == "edit-item") {
        this.formConcentrado.nombre = data.nombre_producto;
        this.formConcentrado.descripcion = data.descripcion_producto;
        this.formConcentrado.codigo_stock = data.codigo_stock;
        this.formConcentrado.precio_compra = data.precio_compra;
        this.formConcentrado.precio_venta = data.precio_venta;
        this.formConcentrado.existencia = data.existencia;
        this.formConcentrado.id = data.id;
        this.showModalE = true;
      }
      if (action == "new-item") {
        this.formConcentrado.nombre = "";
        this.formConcentrado.descripcion = "";
        this.showModalN = true;
      }
      if (action == "desactivate-item") {
        this.formConcentrado.nombre = data.nombre_producto;
        this.formConcentrado.id = data.id;
        this.showModalD = true;
      }
      if (action == "activate-item") {
        this.formConcentrado.nombre = data.nombre_producto;
        this.formConcentrado.id = data.id;
        this.showModalA = true;
      }
    },
  },
  computed: {
    ...authComputed,
    ...mapState("authfack", ["status"]),
    /**
     * Total no. of records
     */
  },
};
</script>
<style>
/* Css para el loading en el modal */
.my-class {
  background: rgba(255, 255, 255, 0);
  color: white;
  border-bottom: 1px solid #f8f8f800;
  border: 1px solid #c02d2d00;
}
</style>
<template>
  <Layout>
    <PageHeader :title="title" :items="itemst" />

    <div class="row">
      <div class="col-12">
        <b-modal
          centered
          v-model="showModalL"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
          no-close-on-backdrop
          content-class="my-class"
          header-class="my-class"
        >
          <template #modal-header="{}">
            <!-- Emulate built in modal header close button action -->

            <h5></h5>
          </template>
          <form>
            <div class="row">
              <div class="col-12">
                <div class="d-flex justify-content-center">
                  <fulfilling-bouncing-circle-spinner
                    :animation-duration="2000"
                    :size="90"
                    color="#2a3042"
                  />
                </div>
              </div>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Activar -->
        <b-modal
          centered
          v-model="showModalA"
          title="Activar Concentrado"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Activar la Concentrado?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalA = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="activate">Activar</b-button>
            </div>
          </form>
        </b-modal>

        <!-- Modal para Desactivar -->
        <b-modal
          centered
          v-model="showModalD"
          title="Desactivar"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form>
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <h4>¿Desea Desactivar la Concentrado?</h4>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalD = false"
                >Cancelar</b-button
              >
              <b-button variant="danger" @click="desactivate"
                >Desactivar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal para Editar-->
        <b-modal
          centered
          v-model="showModalE"
          title="Editar Categoria"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form @submit.prevent="validaciones('update')">
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Nombre</label>
                  <input
                    id="name"
                    v-model="$v.formConcentrado.nombre.$model"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese un nombre"
                    :class="{
                      'is-invalid': $v.formConcentrado.nombre.$error,
                    }"
                    @input="$v.formConcentrado.nombre.$touch()"
                  />
                  <div
                    v-if="
                      $v.formConcentrado.nombre.$error &&
                      !$v.formConcentrado.nombre.required
                    "
                    class="invalid-feedback"
                  >
                    El nombre es obligatorio.
                  </div>
                  <!-- <div
                    v-if="!$v.formConcentrado.nombre.isUnique"
                    :class="{
                      'invalid-feedback': !$v.formConcentrado.nombre.isUnique,
                    }"
                  >
                    El nombre de la Concentrado {{ formConcentrado.nombre }} ya
                    existen en nuestros registros.
                  </div> -->
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Código</label>
                  <input
                              id="name"
                              v-model="$v.formConcentrado.codigo_stock.$model"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese un Codigo"
                              :class="{
                                'is-invalid': $v.formConcentrado.codigo_stock.$error,
                              }"
                              @input="$v.formConcentrado.codigo_stock.$touch()"
                            />
                            <div
                              v-if="  $v.formConcentrado.codigo_stock.$error &&!$v.formConcentrado.codigo_stock.required
                              "
                              class="invalid-feedback"
                            >
                              El Codigo es obligatorio.
                            </div>
                             <div
                              v-if="!$v.formConcentrado.codigo_stock.isUnique"
                              :class="{
                                'invalid-feedback': !$v.formConcentrado.codigo_stock.isUnique,
                              }"
                            >
                                El Codigo {{formConcentrado.codigo_stock}} ya existen en nuestros registros.
                            </div>
                     
                      <barcode :value="formConcentrado.codigo_stock" :options="{ format: 'EAN13' }">
                          generando código de barras
                      </barcode>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Descripción</label>
                  <input
                    id="phone"
                    v-model="formConcentrado.descripcion"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese una Descripción"
                    :class="{
                      'is-invalid':
                        submitted && $v.formConcentrado.descripcion.$error,
                    }"
                  />
                  <div
                    v-if="submitted && !$v.formConcentrado.descripcion.required"
                    class="invalid-feedback"
                  >
                    La descripción es requerida.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Existencia en Lb</label>
                  <input
                    id="phone"
                    v-model="formConcentrado.existencia"
                    type="text"
                    class="form-control"
                    placeholder="La existencia del producto"
                    :class="{
                      'is-invalid':
                        submitted && $v.formConcentrado.existencia.$error,
                    }"
                  />
                  <div
                    v-if="submitted && !$v.formConcentrado.existencia.required"
                    class="invalid-feedback"
                  >
                    La existencia es requerida.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Precio compra</label>
                  <masked-input
                              v-model="$v.formConcentrado.precio_compra.$model"
                              :state="!$v.formConcentrado.precio_compra.$error"
                              :mask="mask_quetzal"
                              class="form-control "
                              :guide="false"
                              :keep-char-positions="true"
                              :show-mask="true"
                              type="text"
                              placeholder="Ingrese un precio"
                              :class="{
                                'is-invalid': $v.formConcentrado.precio_compra.$error,
                              }"
                            
                            />
                            <div
                              v-if="  $v.formConcentrado.precio_compra.$error &&!$v.formConcentrado.precio_compra.required
                              "
                              class="invalid-feedback"
                            >
                              El Precio compra es obligatorio.
                            </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Precio Venta</label>
                  <masked-input
                              v-model="$v.formConcentrado.precio_venta.$model"
                              :state="!$v.formConcentrado.precio_venta.$error"
                              :mask="mask_quetzal"
                              class="form-control "
                              :guide="false"
                              :keep-char-positions="true"
                              :show-mask="true"
                              type="text"
                              placeholder="Ingrese un precio"
                              :class="{
                                'is-invalid': $v.formConcentrado.precio_venta.$error,
                              }"
                            
                            />
                            <div
                              v-if="  $v.formConcentrado.precio_venta.$error &&!$v.formConcentrado.precio_venta.required
                              "
                              class="invalid-feedback"
                            >
                              El Precio venta es obligatorio.
                            </div>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalE = false"
                >Cerrar</b-button
              >
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <!-- Modal de Nuevo Registro-->
        <b-modal
          centered
          v-model="showModalN"
          title="Nueva Concentrado"
          title-class="text-black font-18"
          body-class="p-3"
          hide-footer
        >
          <form @submit.prevent="validaciones('save')">
            <div class="row">
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Nombre</label>
                  <input
                    id="name"
                    v-model="$v.formConcentrado.nombre.$model"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese un nombre"
                    :class="{
                      'is-invalid': $v.formConcentrado.nombre.$error,
                    }"
                    @input="$v.formConcentrado.nombre.$touch()"
                  />
                  <div
                    v-if="
                      $v.formConcentrado.nombre.$error &&
                      !$v.formConcentrado.nombre.required
                    "
                    class="invalid-feedback"
                  >
                    El nombre es obligatorio.
                  </div>
                  <!-- <div
                    v-if="!$v.formConcentrado.nombre.isUnique"
                    :class="{
                      'invalid-feedback': !$v.formConcentrado.nombre.isUnique,
                    }"
                  >
                    El nombre de la Concentrado {{ formConcentrado.nombre }} ya
                    existen en nuestros registros.
                  </div> -->
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="name">Código</label>
                  <input
                              id="name"
                              v-model="$v.formConcentrado.codigo_stock.$model"
                              type="text"
                              class="form-control"
                              placeholder="Ingrese un Codigo"
                              :class="{
                                'is-invalid': $v.formConcentrado.codigo_stock.$error,
                              }"
                              @input="$v.formConcentrado.codigo_stock.$touch()"
                            />
                            <div
                              v-if="  $v.formConcentrado.codigo_stock.$error &&!$v.formConcentrado.codigo_stock.required
                              "
                              class="invalid-feedback"
                            >
                              El Codigo es obligatorio.
                            </div>
                             <div
                              v-if="!$v.formConcentrado.codigo_stock.isUnique"
                              :class="{
                                'invalid-feedback': !$v.formConcentrado.codigo_stock.isUnique,
                              }"
                            >
                                El Codigo {{formConcentrado.codigo_stock}} ya existen en nuestros registros.
                            </div>
                     
                      <barcode :value="formConcentrado.codigo_stock" :options="{ format: 'EAN13' }">
                          generando código de barras
                      </barcode>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Descripción</label>
                  <input
                    id="phone"
                    v-model="formConcentrado.descripcion"
                    type="text"
                    class="form-control"
                    placeholder="Ingrese una Descripción"
                    :class="{
                      'is-invalid':
                        submitted && $v.formConcentrado.descripcion.$error,
                    }"
                  />
                  <div
                    v-if="submitted && !$v.formConcentrado.descripcion.required"
                    class="invalid-feedback"
                  >
                    La descripción es requerida.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Existencia en Lb</label>
                  <input
                    id="phone"
                    v-model="formConcentrado.existencia"
                    type="number"
                    class="form-control"
                    placeholder="La existencia del producto"
                    :class="{
                      'is-invalid':
                        submitted && $v.formConcentrado.existencia.$error,
                    }"
                  />
                  <div
                    v-if="submitted && !$v.formConcentrado.existencia.required"
                    class="invalid-feedback"
                  >
                    La existencia es requerida.
                  </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Precio compra</label>
                  <masked-input
                              v-model="$v.formConcentrado.precio_compra.$model"
                              :state="!$v.formConcentrado.precio_compra.$error"
                              :mask="mask_quetzal"
                              class="form-control "
                              :guide="false"
                              :keep-char-positions="true"
                              :show-mask="true"
                              type="text"
                              placeholder="Ingrese un precio"
                              :class="{
                                'is-invalid': $v.formConcentrado.precio_compra.$error,
                              }"
                            
                            />
                            <div
                              v-if="  $v.formConcentrado.precio_compra.$error &&!$v.formConcentrado.precio_compra.required
                              "
                              class="invalid-feedback"
                            >
                              El Precio compra es obligatorio.
                            </div>
                </div>
              </div>
              <div class="col-12">
                <div class="mb-3">
                  <label for="phone">Precio Venta</label>
                  <masked-input
                              v-model="$v.formConcentrado.precio_venta.$model"
                              :state="!$v.formConcentrado.precio_venta.$error"
                              :mask="mask_quetzal"
                              class="form-control "
                              :guide="false"
                              :keep-char-positions="true"
                              :show-mask="true"
                              type="text"
                              placeholder="Ingrese un precio"
                              :class="{
                                'is-invalid': $v.formConcentrado.precio_venta.$error,
                              }"
                            
                            />
                            <div
                              v-if="  $v.formConcentrado.precio_venta.$error &&!$v.formConcentrado.precio_venta.required
                              "
                              class="invalid-feedback"
                            >
                              El Precio venta es obligatorio.
                            </div>
                </div>
              </div>
            </div>

            <div class="text-end pt-5 mt-3">
              <b-button variant="light" @click="showModalN = false"
                >Cerrar</b-button
              >
              <b-button type="submit" variant="success" class="ms-1"
                >Guardar</b-button
              >
            </div>
          </form>
        </b-modal>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Listado de Concentrado</h4>
              <div class="row">
                <div class="col-sm-6 text-md-end">
                <div v-if="userT.role == 1 || userT.role == '1'" class="mt-2 p-3" style="background-color: #f0f8ff; border: 1px solid #d1e7dd; border-radius: 8px;">
                  <strong class="text-primary" style="font-size: 1.5rem;">Inversión:</strong>
                  <span class="text-success" style="font-size: 1.5rem;">{{ money(totalInversion) }}</span>
                </div>
              </div>
              </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-2">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Mostrar&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      @input="changePageSize()"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-2">
                <div
                  id="tickets-table_length"
                  class="dataTables_length text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <b-dropdown v-if="searchType" id="ddown1" size="sm">
                      <template v-slot:button-content>
                        {{ "Ordenar por: " + searchLabel.nombre }}
                        <i class="mdi mdi-chevron-down"></i>
                      </template>
                      <b-dropdown-item
                        v-for="(search, index) in searchType"
                        :key="index"
                        @click="changeTypeSearch(search)"
                        >{{ search.nombre }}</b-dropdown-item
                      >
                    </b-dropdown>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-3 text-md-start">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    <b-form-input
                      v-model="search"
                      type="search"
                      @input="onFiltered()"
                      placeholder="Buscar..."
                      class="form-control form-control-sm"
                    ></b-form-input>
                  </label>
                </div>
              </div>

              <div class="col-sm-12 col-md-5">
                <div
                  id="tickets-table_filter"
                  class="dataTables_filter text-md-end"
                >
                  <label class="d-inline-flex align-items-center">
                    <button
                      type="button"
                      class="btn btn-success btn-rounded mb-2 me-2"
                      @click="onActionClicked('new-item')"
                    >
                      <i class="mdi mdi-plus me-1"></i> Nueva Concentrado
                    </button>
                  </label>
                </div>
              </div>

              <!-- End search -->
            </div>
            <!-- Table -->
            <Loader :loading="loadingtable">
              <vuetable
                ref="vuetable"
                class="table-divided table-responsive order-with-arrow"
                :css="css.table"
                :api-url="apiBase"
                :reactive-api-url="true"
                :fields="fields"
                :http-options="httpOptions"
                :per-page="perPage"
                :query-params="makeQueryParams"
                pagination-path
                @vuetable:pagination-data="onPaginationData"
              >
                <div slot="actions" slot-scope="props">
                  <b-button-group class="mt-4 mt-md-0">
                    <b-button
                      v-if="props.rowData.estado_producto"
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Editar"
                      variant="outline-primary"
                      @click="onActionClicked('edit-item', props.rowData)"
                      ><i class="bx bx-edit-alt"></i>
                    </b-button>

                    <b-button
                      tabindex="0"
                      v-b-tooltip.focus
                      title="Cambiar Estado"
                      :variant="
                        props.rowData.estado_producto == true
                          ? 'outline-danger'
                          : 'outline-success'
                      "
                      @click="
                        props.rowData.estado_producto == true
                          ? onActionClicked('desactivate-item', props.rowData)
                          : onActionClicked('activate-item', props.rowData)
                      "
                    >
                      <i
                        :class="
                          props.rowData.estado_producto == true
                            ? 'bx bx-trash-alt'
                            : 'bx bx-list-check'
                        "
                      ></i>
                    </b-button>
                  </b-button-group>
                </div>

                <div slot="estado" slot-scope="props">
                  <h5 v-if="props.rowData.estado_producto == true">
                    <span class="badge bg-success ms-1"
                      ><strong>ACTIVO</strong></span
                    >
                  </h5>
                  <h5 v-else>
                    <span class="badge bg-danger ms-1"
                      ><strong>INACTIVO</strong></span
                    >
                  </h5>
                </div>
                <div slot="precio_compra" slot-scope="props">
                  {{
                    money(props.rowData.precio_compra)
                  }}
                </div>
                <div slot="precio_venta" slot-scope="props">
                  {{
                    money(props.rowData.precio_venta)
                  }}
                </div>
              </vuetable>
              <div style="padding-top: 10px">
                <vuetable-pagination
                  ref="pagination"
                  :css="css.pagination"
                  @vuetable-pagination:change-page="onChangePage"
                ></vuetable-pagination>
              </div>
            </Loader>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>./concentrado.vue
